import { render, staticRenderFns } from "./StatusCard.vue?vue&type=template&id=56908f12&scoped=true&"
import script from "@/components/status-card/StatusCard.ts?vue&type=script&lang=ts&"
export * from "@/components/status-card/StatusCard.ts?vue&type=script&lang=ts&"
import style0 from "@/components/status-card/status-card.scss?vue&type=style&index=0&id=56908f12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56908f12",
  null
  
)

export default component.exports